import ReactMarkdown from 'react-markdown';

export function Markdown({ children }) {
  return (
    <div className="markdown-body">
      <ReactMarkdown
        allowedElements={['p', 'h2', 'h3', 'ul', 'ol', 'li', 'a', 'strong', 'em', 'blockquote', 'br']}
        unwrapDisallowed
        components={{
          h2: (p) => <h2 className="mt-8 font-serif text-2xl font-bold sm:text-3xl" {...p} />,
          h3: (p) => <h3 className="mt-6 font-serif text-xl font-bold" {...p} />,
          p: (p) => <p className="mt-4 leading-relaxed text-brand-brown/90" {...p} />,
          ul: (p) => <ul className="mt-4 list-disc space-y-2 pl-6 leading-relaxed text-brand-brown/90 marker:text-brand-gold" {...p} />,
          ol: (p) => <ol className="mt-4 list-decimal space-y-2 pl-6 leading-relaxed text-brand-brown/90 marker:text-brand-gold" {...p} />,
          a: (p) => <a className="link-inline" {...p} />,
          blockquote: (p) => <blockquote className="mt-4 border-l-2 border-brand-gold pl-4 italic text-brand-brown-soft" {...p} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
